import { makeObservable, override } from 'mobx'

import { FilterStore } from 'shared/stores'

class SearchStore extends FilterStore {
  constructor (...props) {
    super(...props)
    makeObservable(this)
    this._value = '' // Ensure value is string at init
  }

  @override
  clearFilter () {
    this._value = ''
    this.deactivate()
  }
}

export default SearchStore
